import { LabelHTMLAttributes } from 'react';
import { StyledLabel } from './styles';
import { SafeMarkdown } from '../markdown/safe';

interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  text: string;
  disabled?: boolean;
}

export const Label = ({ text, disabled }: LabelProps) => {
  return (
    <StyledLabel disabled={disabled}>
      <SafeMarkdown text={text} />
    </StyledLabel>
  );
};
